import { requestAll } from '@helpers/requestAll.js'
import { PRIVATE_BASE_URL } from '@config/game.js'

/* API request to get **all** user team summary */
export function getAllUserTeamSummaryRequest() {
  return requestAll(`${PRIVATE_BASE_URL}/me/teams`)
}
